<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card v-can="'view-budget-tool'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
                 :collapse-action="true">

          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <customer-dropdown
                v-on:onInput="value => filters['customer_id'] = value ? value.id : null"
                :selected_customer_data="filters['customer_id']"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Formulations</label>
              <v-select :clearable="true" name="formulations" placeholder="" label="formulation_code"
                        v-model="filters['formulation_id']"
                        :options="formulations"
                        :reduce="option => option.id"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">From Date</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['from_date']"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">To Date</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date To" v-model="filters['to_date']"/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={ customer_id: null }">CLEAR
              </vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card title="BUDGET TOOL">
          <template slot="actions">
            <vs-button v-can="'view-budget-tool'"
                       @click="downloadBudgetToolDocument" class="mr-4" color="primary" type="filled">Download Budget Document
            </vs-button>
            <vs-button v-can="'create-edit-budget-tool'" @click="createBudgetTool" class="mr-4" color="primary" type="filled">Create Budget
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4" v-can="'view-budget-tool'">
            <vs-table
              id="forecast-list"
              :data="budget_tools"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="thead">
                <vs-th width="15%">CUSTOMER NAME</vs-th>
                <vs-th width="15%">CUSTOMER ACC NUMBER</vs-th>
                <vs-th width="50%">PRODUCTS</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="index" v-for="(tr, index) in data" @click.native="updateBudgetTool(data[index])">
                  <vs-td :data="data[index].company_name">
                    {{ data[index].company_name }}
                  </vs-td>
                  <vs-td :data="data[index].account_number">
                    {{ data[index].account_number }}
                  </vs-td>
                  <vs-td :data="data[index].budget_tools">
                    <span v-for="(tool, indextr) in data[index].budget_tools" :key="indextr">
                      {{ tool.formulation_code }} <span v-if="index + 1 !== data[index].budget_tools.length">,</span>
                    </span>
                  </vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View & update" position="left" v-can="'edit-budget-tool'">
                        <vs-button
                          size="small" color="primary" @click.stop="updateBudgetTool(data[index])" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!--            <vs-pagination-->
            <!--              v-on:changeMaxItems="changePage"-->
            <!--              :size-array="forecast_meta.total"-->
            <!--              :max-items="perPage"-->
            <!--              description-body="Rows per page"-->
            <!--              description-connector="of"-->
            <!--              description-title="Records"-->
            <!--              description-->
            <!--              :description-items="descriptionItems"-->
            <!--              :total="(forecast_meta.last_page)? forecast_meta.last_page : 0"-->
            <!--              v-model="page" class="p-5">-->
            <!--            </vs-pagination>-->
          </div>
        </vx-card>
<!--        <create-budget-tool ref="CreateBudgetTool"/>-->
        <update-budget-tool ref="UpdateBudgetTool" v-on:onClickAddNewProduct="onClickAddNewProduct"/>
        <download-budget-document-pop-up ref="DownloadBudgetDocumentPopUp"/>
        <vs-prompt
          @cancel="activeSelectCustomerPrompt = false"
          @accept="onClickSelectCustomer"
          @close="activeSelectCustomerPrompt = false"
          title="Create Budget Tool"
          accept-text="Confirm"
          color="primary"
          :active.sync="activeSelectCustomerPrompt">
          <div class="con-exemple-prompt">
            <customer-dropdown
              v-on:onInput="value => selected_customer_obj = value ? value : null"
              :selected_customer_data="selected_customer_obj"
            />
          </div>
        </vs-prompt>
      </div>
    </div>
  </div>
</template>

<script>

import {RepositoryFactory} from "@/repository/RepositoryFactory";
import {mapActions, mapGetters} from "vuex";
import {defaultPagination, perPageList} from "@/constants/config";
import moment from "moment/moment";
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import CreateBudgetTool from "@/components/popups/budget-tool/CreateBudgetTool";
import UpdateBudgetTool from "@/components/popups/budget-tool/UpdateBudgetTool";
import DownloadBudgetDocumentPopUp from "@/components/popups/budget-tool/DownloadBudgetDocumentPopUp";



const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const DropDownRepository = RepositoryFactory.get('drop_down')
import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";

export default {
  name: "BudgetToolList",
  data () {
    return {
      filters: { customer_id: null },
      page: 1,
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      formulations: [],
      activeSelectCustomerPrompt: false,
      selected_customer_obj: {},
      filterQuery: '',
    }
  },
  components:{
    DownloadBudgetDocumentPopUp,
    UpdateBudgetTool,
    // CreateBudgetTool,
    'v-select': vSelect,
    flatPickr,
    CustomerDropdown
  },
  mounted() {
    this.fetchBudgetToolList()
    this.fetchFormulations()
  },
  computed: {
    ...mapGetters({
      budget_tools: 'budgetTools',
    })
  },
  methods:{
    ...mapActions(['fetchAllBudgetTools']),
    refreshData() {
      this.fetchBudgetToolList()
    },
    async fetchBudgetToolList() {
      try {
        await this.fetchAllBudgetTools({filterQuery: this.filterQuery})
      } catch (error) {

      }
    },
    async fetchFormulations() {
      this.$vs.loading();
      const {data} = (await FormulationsRepository.getListOfFormulationNoPagination(0)).data
      this.formulations = data
      this.$vs.loading.close()
    },
    async createBudgetTool() {
      this.activeSelectCustomerPrompt = true
    },
    async updateBudgetTool(data){
      await this.$refs.UpdateBudgetTool.openPopup({ id: data.id, company_name: data.company_name })
    },
    async downloadBudgetToolDocument(){
      await this.$refs.DownloadBudgetDocumentPopUp.openPopup(this.filters)
    },
    filterQueryUpdate() {
      this.fetchBudgetToolList()
    },
    async onClickSelectCustomer() {
      const if_exists = this.budget_tools.find((x) => x.account_number === this.selected_customer_obj.account_number)
      if(!if_exists) {
        await this.$refs.UpdateBudgetTool.openPopup(
          { id: this.selected_customer_obj.id, company_name: this.selected_customer_obj.company_name }
        )
      } else {
        await this.$refs.UpdateBudgetTool.openPopup(
          { id: this.selected_customer_obj.id, company_name: this.selected_customer_obj.company_name }
        )
      }
    },
    onSearchCustomer(search, loading) {
      if(search.length) {
        loading(true);
        this.searchCustomer(loading, search, this);
      }
    },
    searchCustomer: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getCustomersList(`filter[search]=${search}`)
      vm.customers = data.data
      loading(false);
    }, 350),
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onClickAddNewProduct(customer_data) {
      await this.$refs.CreateBudgetTool.openPopup(customer_data)
    }
  },
  watch: {
    page() {
      this.fetchBudgetToolList()
    },
    perPage() {
      this.fetchBudgetToolList()
    },
    'filters': {
      handler (value) {
        clearTimeout(this.timer)
        this.filterQuery = ''
        const queries = []
        for (const filter in value) {
          if (this.filters[filter] && this.filters[filter] !== '') {
            if (this.filters[filter] instanceof Date) {
              queries.push(`${filter}=${encodeURIComponent(moment(this.filters[filter]).format('YYYY-MM-DD'))}`)
            } else {
              queries.push(`${filter}=${encodeURIComponent(this.filters[filter])}`)
            }
          }
        }
        if (queries.length > 0) this.filterQuery = queries.join('&')
        const that = this
        this.timer = setTimeout(function () {
          that.fetchBudgetToolList()
        }, 500)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
